<button
  class="underline medium-type link-hover nordic-blue-900-text font-body-1 align-left"
  data-test-discount-code-button
  (click)="openModal()"
>
  {{
    (discountCode$ | async)
      ? ('promoCode.buttonWithCode' | finLocalization: { code: (discountCode$ | async) })
      : ('promoCode.emptyButton' | finLocalization)
  }}
</button>

<fcom-modal
  [(open)]="modalOpen"
  [title]="'promoCode.modalTitle' | finLocalization"
  [fitToContent]="true"
  [buttons]="ModalButtons.CUSTOM"
  [focusTarget]="discountCodeInput.inputElement"
  data-test-discount-code-modal
>
  <div class="ps-large">
    <div class="pr-xsmall-b" data-test-discount-code-form>
      <fcom-text-input
        [id]="'discount-code-input'"
        [parentForm]="discountCodeForm"
        [translationPrefix]="'bookingWidget.promoCode.inputLabel'"
        [controlName]="'discountCode'"
        [required]="false"
        [displayMargin]="false"
        (keyup.enter)="checkDiscountCode()"
        #discountCodeInput
      ></fcom-text-input>
    </div>

    <p
      data-test-discount-code-login-warning
      *ngIf="!(discountCodeRules$ | async)?.found && !discountCodeForm.controls.discountCode.hasError('custom')"
    >
      {{ 'promoCode.loginWarning' | finLocalization }}
    </p>
    <p data-test-discount-code-generic-error *ngIf="discountCodeForm.controls.discountCode.hasError('custom')">
      {{ 'promoCode.genericError' | finLocalization }}
    </p>

    <ng-container *ngIf="(discountCodeRules$ | async)?.found; else discountCodeGeneralInfo">
      <div class="discount-code-rules">
        <div class="nordic-blue-900-text mr-xsmall-b font-body-1">{{ 'promoCode.termsTitle' | finLocalization }}</div>
        <div class="nordic-blue-900-text font-body-1">{{ (discountCodeRules$ | async).title }}</div>
        <div class="mr-small-l" [innerHTML]="(discountCodeRules$ | async).terms | resolveLinks | finSafe: 'html'"></div>
      </div>
    </ng-container>
  </div>

  <ng-template #discountCodeGeneralInfo>
    <a
      data-test-discount-code-general-info
      [finLink]="'promoCode.termsLink.url' | finLocalization"
      [external]="true"
      [openInNewTab]="true"
      class="underline medium-type link-hover nordic-blue-900-text font-body-1 mr-xsmall-t block"
      ><span class="ms-xxsmall-r">{{ 'promoCode.promoLinkText' | finLocalization }}</span>
      <fcom-icon class="external-link is-xsmall" name="external-tab"></fcom-icon
    ></a>
  </ng-template>

  <div buttons>
    <fcom-button
      data-test-discount-code-remove
      *ngIf="(discountCodeRules$ | async)?.found"
      class="mr-xsmall-r"
      [loading]="loading$ | async"
      [size]="ButtonSize.S_SMALL"
      [theme]="ButtonTheme.SECONDARY"
      [disabled]="false"
      [text]="'promoCode.removeCodeButton' | finLocalization"
      [aria]="{ label: 'promoCode.removeCodeButton' | finLocalization, role: 'button' }"
      (click)="resetForm()"
    ></fcom-button>
    <fcom-button
      data-test-discount-code-check
      *ngIf="!(discountCodeRules$ | async)?.found"
      class="mr-xsmall-r"
      [loading]="loading$ | async"
      [size]="ButtonSize.S_SMALL"
      [theme]="ButtonTheme.PRIMARY_BLUE"
      [disabled]="
        discountCodeForm.controls.discountCode.value === null ||
        discountCodeForm.controls.discountCode.value === '' ||
        !discountCodeForm.controls.discountCode.valid
      "
      [text]="'promoCode.checkCodeButton' | finLocalization"
      [aria]="{ label: 'promoCode.checkCodeButton' | finLocalization, role: 'button' }"
      (click)="checkDiscountCode()"
    ></fcom-button>
    <fcom-button
      data-test-discount-code-continue
      *ngIf="(discountCodeRules$ | async)?.found"
      [loading]="loading$ | async"
      [size]="ButtonSize.S_SMALL"
      [theme]="ButtonTheme.PRIMARY_BLUE"
      [disabled]="false"
      [text]="'actions.continue' | finLocalization"
      [aria]="{ label: 'actions.continue' | finLocalization, role: 'button' }"
      (click)="continue()"
    ></fcom-button>
  </div>
</fcom-modal>
